<template>
  <div class="single-specials specials-summary">

    <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>

    <div v-if="!loading && data">

      <ion-row>
        <ion-col size="12">
          <div class="padding">
            <div class="text-center">
              <h1 class="h2 text-normal mb-10">{{ title }}</h1>
              <h2 class="h3">Realizacja zadania</h2>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
          <div class="padding">
            <div class="text-center">

              <div class="form mb-20" v-if="$store.getters.getPlaces.length > 0">
                <div class="form-group">
                  <div class="select-wrapper">
                    <span v-if="place === null" class="select-placeholder">Wybierz sklep</span>
                    <select v-model="place" @change="this.getData">
                      <option v-for="item in $store.getters.getPlaces" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div v-if="subtitle" class="mb-20">
                <p>{{ subtitle.label }}: <strong>{{ subtitle.value }}</strong></p>
              </div>

              <div v-if="targets" class="list">
                <div class="item" v-for="(item, index) in targets">

                  <item-progress
                    :title="(item.title ? item.title : 'Wyzwanie') +': '+item.target+' punktów'"
                    :value="item.realizationPercent"
                    suffix="%"
                    :bar="true"
                    label=""
                    :remaining="item.stillLeft"
                    :remainingLabel="item.stillLeftLabel"
                    size="large"
                    color="#ff0000">
                  </item-progress>

                  <div v-if="item.targetQualification && item.realizationPercentQualification" class="mt-20">
                    <item-progress
                      :title="(item.title ? item.title : 'Wyzwanie') +': '+item.targetQualification+' punktów'"
                      :value="item.realizationPercentQualification"
                      suffix="%"
                      :bar="true"
                      label=""
                      :remaining="item.stillLeftQualification"
                      :remainingLabel="item.stillLeftQualificationLabel"
                      size="large"
                      color="#ff0000">
                    </item-progress>
                  </div>

                  <hr class="mt-20"/>
                </div>

                <!--"aktywacja warunkowa"-->
                <div v-if="targetsArr[0].type == 1" class="padlock-wrapper">
                  <div class="svg-wrapper svg-inline svg-rwd svg-animate">
                    <svg-padlock-steps ref="padlock"
                                       pause="false"
                                       id="PadlockSmall"
                                       :showQuestionsLabel="false"
                                       :totalQuestions="numberOfTargets"
                                       :passedQuestions="numberOfFinishedTargets"
                                       :hintText="padlockHintText">
                    </svg-padlock-steps>
                  </div>
                </div>

              </div>
              <div v-else>
                <p>Brak danych</p>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>

    </div>

  </div>
</template>

<script>
  import ItemProgress from "../../../items/ItemProgress.vue";
  import SpecialsServices from '../../../services/SpecialsServices';
  import SvgPadlockSteps from "../../../components/svgplus/SvgPadlockSteps";

  export default {
    name: 'SpecialsSummary',
    components: {ItemProgress, SvgPadlockSteps},
    props: {
      slug: {
        type: [String, Number],
        requred: true
      }
    },
    data: () => ({
      loading: true,
      errors: [],
      dataCollection: null
    }),
    computed: {
      data() {
        return this.dataCollection[0];
      },
      title() {
        return this.data.title
      },
      subtitle(){
        return this.data.subtitle
      },
      targets() {
        return this.data.targets
      },
      targetsArr() {
        return Object.values(this.targets); // convert object(obj, obj..) into array
      },
      numberOfTargets() {
        return Object.keys(this.targets).length
      },
      numberOfFinishedTargets() {
        let num = 0
        this.targetsArr.forEach((value) => {
          return (value.stillLeft == 0) ? num++ : 0;
        }, 0)
        return num
      },
      // sumOfTargets() {
      //   // return Object.keys(this.targets).reduce((total, current) => total + current); // keys are risky!
      // },
      sumOfStillLeft() {
        let sum = this.targetsArr.reduce((total, current) => {
          return total + parseFloat(current.stillLeft);
        }, 0)
        return sum
      },
      padlockHintText() {
        if (this.sumOfStillLeft == 0) {
          return 'Bonus został odblokowany - gratulujemy!'
        } else {
          return 'Odblokuj możliwość zdobycia bonusu za realizację wyzwania specjalnego oraz wyzwania głównego.'
        }
      },
      place: {
        set(place) {
          this.$store.commit('USER_SET_PLACE', place)
        },
        get() {
          return this.$store.state.user.currentPlace || null
        }
      }
    },
    methods: {
      getData() {
        this.loading = true;
        SpecialsServices.getSpecialTaskSummary(this.slug, this.$store.state.user.currentPlace)
          .then((response) => {
            this.loading = false;

            if (response.code == 0) {
              this.errors.push(response.message)
            } else {
              this.dataCollection = response.data.data;
              //
              this.playAnimate();
            }

            // FIX scroll to top
            const element = document.querySelector('#topOfDocument');
            element.scrollIntoView()
          })
          .catch((e) => {
            this.errors.push(e.toString())
          })
      },
      playAnimate() {
        setTimeout(() => {
          // this.$refs.padlock[0].playAnimate();
          if(!this.$refs.padlock) return
          this.$refs.padlock.playAnimate();
        }, 500)
      },
    },
    mounted() {
      this.getData();
    }
  }
</script>
